import { Skeleton } from "antd";
export default function LabelRowList({sideButton = true, descRows=1, boxLimit=0}) {
  return (
    <div
      style={{
        display:"flex",
        flexWrap:"wrap",
        justifyContent:"space-between",
        padding: "40px 20px",
        border: "2px solid #e5e5e5",
        borderRadius: "10px",
        marginBottom: "10px",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            flexWrap:"wrap",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Skeleton.Avatar active size={50} />
            <div style={{ marginLeft: 20 }}>
                <Skeleton.Input
                  active
                  size={20}
                  style={{ width: 150, marginBottom: 8 }}
                />
            </div>
          </div>
          
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent:"center", marginTop: 10 }}>
          {/* <Skeleton.Input active size={14} style={{ width: "100%" }} /> */}
          {Array.from({length:descRows}).map((_, i)=>(
            <Skeleton.Input key={i} active size={14} style={{ width: "80%" }} />
          ))}
        </div>
      </div>
        <div>
        {sideButton && <Skeleton.Button active size="default" style={{ width: 100 }} /> }
        <div style={{display:"flex", flexWrap:"wrap", alignItems:"center", gap:50}} >
          {Array.from({length:boxLimit}).map((_, i)=>(
            <Skeleton.Node active key={i} style={{width:110, height:110, borderRadius:8}} />
          ))}
        </div>
        </div>
      
    </div>
  );
}
